import { render, staticRenderFns } from "./WALLET.vue?vue&type=template&id=62abacd2"
import script from "./WALLET.vue?vue&type=script&lang=js"
export * from "./WALLET.vue?vue&type=script&lang=js"
import style0 from "@/styles/iframe.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_cache-loader@4.1.0_webpack@4.47.0__css-load_1b3fe109433f9fe6108f2b5a977879df/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports